import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { stStatusOptions } from "../../../static/dropdown";
import { fetchDataByQuery } from "../../../service/dataExport";
import { allCvReport } from "../../../static/reportQuery";

const CvTables = ({
  totalSopReport,
  totalReportLoading,
  visaSopReport,
  visaSopReportLoading,
  cvReport,
  cvReportLoading,
  cvUserWiseReport,
  userWiseLoading,
  admSopUserReportLoading,
  admSopUserReport,
  visaUserWiseReport,
  userWiseVisaLoading,
}) => {
  const hasData =
    cvReport &&
    typeof cvReport === "object" &&
    Object.keys(cvReport).length > 0;
  const hasUserWiseData =
    cvUserWiseReport &&
    typeof cvReport === "object" &&
    Object.keys(cvUserWiseReport).length > 0;

  const hasAdmSopUserReport = admSopUserReport && admSopUserReport.length > 0;
  const hasAdmSopVisaUserReport =
    visaUserWiseReport && visaUserWiseReport.length > 0;

  return (
    <div className="container-fluid">
      {/* <div className="mb-3">
        <div className="header">
          <h5 className="fw-bold">CV Reports</h5>
        </div>
        {!cvReportLoading ? (
          <div className="row row-cols-2 row-cols-lg-6 g-2 g-lg-3">
            <div className="col">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="header d-flex flex-column align-items-center">
                    <span className="h6">Total Students</span>
                    <span className="fs-3 fw-bold">
                      {cvReport?.totalStudents?.count || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="header d-flex flex-column align-items-center">
                    <span className="h6">Pending CV</span>
                    <span className="fs-3 fw-bold">
                      {cvReport?.pendingCv?.count || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="header d-flex flex-column align-items-center">
                    <span className="h6">CV In-process</span>
                    <span className="fs-3 fw-bold">
                      {cvReport?.inProcess?.count || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="header d-flex flex-column align-items-center">
                    <span className="h6">CV Review Pending</span>
                    <span className="fs-3 fw-bold">
                      {cvReport?.reviewPending?.count || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="header d-flex flex-column align-items-center">
                    <span className="h6">CV Final Uploaded</span>
                    <span className="fs-3 fw-bold">
                      {cvReport?.finalCv?.count || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="header d-flex flex-column align-items-center">
                    <span className="h6">CV Uploaded</span>
                    <span className="fs-3 fw-bold">
                      {cvReport?.cvUpload?.count || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row row-cols-2 row-cols-lg-6 g-2 g-lg-3 my-3">
            {Array(6)
              .fill(0)
              .map((_, index) => (
                <div className="col" key={index}>
                  <SkeletonTheme highlightColor="#fff3cd">
                    <Skeleton
                      height={70}
                      width="100%"
                      style={{ marginBottom: "10px" }}
                    />
                  </SkeletonTheme>
                </div>
              ))}
          </div>
        )}
      </div> */}
      {!cvReportLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className="bg-white mb-2">
                <span className="fs-5 fw-bold">All CV Reports</span>
              </div>
              <div className="overflow-auto wb-scrollbar-w-1">
                {hasData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr className="text-nowrap">
                        <th>Total Students</th>
                        <th>Pending CV</th>
                        <th>CV Not Required</th>
                        <th>Temp final CV</th>
                        <th>Review Pending</th>
                        <th>Final CV</th>
                        <th>Total Uploaded CV</th>
                        <th>Total Not Uploaded CV</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-center cursor-pointer">
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              cvReport?.totalStudents?.query,
                              allCvReport.cvReport,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {cvReport?.totalStudents?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              cvReport?.pendingCv?.query,
                              allCvReport.cvReport,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {cvReport?.pendingCv?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              cvReport?.cvNotRequired?.query,
                              allCvReport.cvReport,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {cvReport?.cvNotRequired?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              cvReport?.inProcess?.query,
                              allCvReport.cvReport,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {cvReport?.inProcess?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              cvReport?.reviewPending?.query,
                              allCvReport.cvReport,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {cvReport?.reviewPending?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              cvReport?.finalCv?.query,
                              allCvReport.cvReport,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {cvReport?.finalCv?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              cvReport?.cvUpload?.query,
                              allCvReport.cvReport,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {cvReport?.cvUpload?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              cvReport?.cvNotUpload?.query,
                              allCvReport.cvReport,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {cvReport?.cvNotUpload?.count || 0}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!userWiseLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="header mb-2">
                <span className="fs-5 fw-bold">CV Reports Team-wise</span>
              </div>
              <div className="overflow-auto wb-scrollbar-w-1">
                {hasUserWiseData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="">
                      <tr>
                        <th className="text-start">User</th>
                        <th>Students Assigned</th>
                        <th>Pending CV</th>
                        <th>Not Required</th>
                        <th>Temp Final</th>
                        <th>Review Pending</th>
                        <th>Final CV</th>
                        <th>Total Uploaded CV</th>
                        <th>Pending to Uploaded</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cvUserWiseReport?.map(({ name, details }, idx) => (
                        <tr key={idx} className="text-nowrap text-center">
                          <td>{name}</td>
                          <td>{details?.allStudents?.count}</td>
                          <td>{details?.pendingCv?.count}</td>
                          <td>{details?.cvNotRequired?.count}</td>
                          <td>{details?.inProcess?.count}</td>
                          <td>{details?.reviewPending?.count}</td>
                          <td>{details?.finalCv?.count}</td>
                          <td>{details?.cvUpload?.count}</td>
                          <td>{details?.cvNotUpload?.count}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="">
                      <tr>
                        <th className="text-start">Total</th>
                        <th className="text-center">
                          {cvUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.allStudents?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {cvUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.pendingCv?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {cvUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.cvNotRequired?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {cvUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.inProcess?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {cvUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.reviewPending?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {cvUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.finalCv?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {cvUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.cvUpload?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {cvUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.cvNotUpload?.count || 0),
                            0
                          )}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>Data is loading...</p>
      )}

      {!totalReportLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="mb-2">
                <span className="fs-5 fw-bold text-dark">
                  Admission SOP Reports
                </span>
              </div>
              <div className="overflow-auto wb-scrollbar-w-1">
                <table className="table table-yesgermany table-bordered">
                  <thead>
                    <tr className="text-nowrap">
                      <th>Total Students</th>
                      <th>Total Approved Application</th>
                      <th>SOP Not Required</th>
                      <th>Assigned to freelancer</th>
                      <th>Assigned to YG team</th>
                      <th>CV Pending</th>
                      <th>SOP draft created</th>
                      <th>First draft uploaded</th>
                      <th>In Review</th>
                      <th>Completed</th>
                      <th>Uploaded SOP of Completed</th>
                      <th>Not Uploaded SOP of Completed</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-center">
                      <td>{totalSopReport?.totalStudents?.count}</td>
                      <td>{totalSopReport?.approvedApplication?.count}</td>
                      <td>{totalSopReport?.sopNotRequired?.count}</td>
                      <td>{totalSopReport?.assgToFreelancer?.count}</td>
                      <td>{totalSopReport?.assgToYg?.count}</td>
                      <td>{totalSopReport?.cvPending?.count}</td>
                      <td>{totalSopReport?.sopDraftCreated?.count}</td>
                      <td>{totalSopReport?.firstDraftUploaded?.count}</td>
                      <td>{totalSopReport?.inReview?.count}</td>
                      <td>{totalSopReport?.completed?.count}</td>
                      <td>{totalSopReport?.sopUploaded?.count}</td>
                      <td>{totalSopReport?.completed_notUploaded?.count}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>Data is loading...</p>
      )}

      {!admSopUserReportLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="mb-2">
                <span className="fs-5 fw-bold text-dark">
                  Admission Report Team-wise
                </span>
              </div>
              <div className="overflow-auto wb-scrollbar-w-1">
                {hasAdmSopUserReport ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="">
                      <tr className="text-nowrap">
                        <th>Team Member</th>
                        <th>Students Assigned</th>
                        <th>Total Approved Application</th>
                        <th>SOP Not Required</th>
                        <th>Assigned to freelancer</th>
                        <th>Assigned to YG team</th>
                        <th>CV Pending</th>
                        <th>SOP draft created</th>
                        <th>First draft uploaded</th>
                        <th>In Review</th>
                        <th>Completed</th>
                        <th>Uploaded SOP of Completed</th>
                        <th>Not Uploaded SOP of Completed</th>
                      </tr>
                    </thead>
                    <tbody>
                      {admSopUserReport?.map(({ name, details }, idx) => (
                        <tr key={idx} className="text-center">
                          <td className="text-start">{name}</td>
                          <td>{details?.totalStudents?.count}</td>
                          <td>{details?.approvedApplication?.count}</td>
                          <td>{details?.sopNotRequired?.count}</td>
                          <td>{details?.assgToFreelancer?.count}</td>
                          <td>{details?.assgToYg?.count}</td>
                          <td>{details?.cvPending?.count}</td>
                          <td>{details?.sopDraftCreated?.count}</td>
                          <td>{details?.firstDraftUploaded.count}</td>
                          <td>{details?.inReview?.count}</td>
                          <td>{details?.completed?.count}</td>
                          <td>{details?.sopUploaded?.count}</td>
                          <td>{details?.completed_notUploaded?.count}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="">
                      <tr>
                        <th className="text-start">Total</th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.totalStudents?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.approvedApplication?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.sopNotRequired?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.assgToFreelancer?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.assgToYg?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.cvPending?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.sopDraftCreated?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.firstDraftUploaded?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.inReview?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.completed?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.sopUploaded?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {admSopUserReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.completed_notUploaded?.count || 0),
                            0
                          )}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>Data is loading...</p>
      )}

      {!visaSopReportLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="mb-2">
                <span className="fs-5 fw-bold">Visa SOP Reports</span>
              </div>
              <div className="overflow-auto wb-scrollbar-w-1">
                <table className="table table-yesgermany table-bordered">
                  <thead>
                    <tr className="text-nowrap">
                      <th>Total Students</th>
                      {/* <th>Admission Amount Received</th> */}
                      <th>Final Accepted</th>
                      <th>Not Updated</th>
                      <th>Wrong SOP Uploaded</th>
                      <th>SOP Under Process</th>
                      <th>SOP Draft Completed</th>
                      <th>SOP First Draft Uploaded</th>
                      <th>SOP In Review</th>
                      <th>Completed</th>
                      <th>SOP File Uploaded</th>
                      <th>SOP File Not Uploaded</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-center">
                      <td>{visaSopReport?.totalStudents?.count}</td>
                      {/* <td>{visaSopReport?.admAmtRecieved?.count}</td> */}
                      <td>{visaSopReport?.finalAccepted?.count}</td>
                      <td>{visaSopReport?.notUpdated?.count}</td>
                      <td>{visaSopReport?.completed_wrong_uploaded?.count}</td>
                      <td>
                        {visaSopReport?.completed_under_process_uploaded?.count}
                      </td>
                      <td>{visaSopReport?.completed_draft_uploaded?.count}</td>
                      <td>
                        {visaSopReport?.completed_first_draft_uploaded?.count}
                      </td>
                      <td>
                        {visaSopReport?.completed_in_review_uploaded?.count}
                      </td>
                      <td>{visaSopReport?.completed?.count}</td>
                      <td>{visaSopReport?.completed_uploaded?.count}</td>
                      <td>{visaSopReport?.completed_not_uploaded?.count}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>Data is loading...</p>
      )}

      {!userWiseVisaLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="header mb-2">
                <span className="fs-5 fw-bold text-dark">
                  Visa Report Team-wise
                </span>
              </div>
              <div className="overflow-auto wb-scrollbar-w-1">
                {hasAdmSopVisaUserReport ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="table-secondary">
                      <tr className="text-nowrap">
                        <th>Team Member</th>
                        <th>Students Assigned</th>
                        <th>Not Updated</th>
                        <th>Final Accepted</th>
                        <th>Not Updated</th>
                        <th>Wrong SOP Uploaded</th>
                        <th>SOP Under Process</th>
                        <th>SOP Draft Completed</th>
                        <th>SOP First Draft Uploaded</th>
                        <th>SOP In Review</th>
                        <th>Completed</th>
                        <th>SOP File Uploaded</th>
                        <th>SOP File Not Uploaded</th>
                      </tr>
                    </thead>
                    <tbody>
                      {visaUserWiseReport?.map(({ name, details }, idx) => (
                        <tr key={idx} className="text-center">
                          <td className="text-start">{name}</td>
                          <td>{details?.totalStudents?.count}</td>
                          <td>{details?.notUpdated?.count}</td>
                          <td>{details?.finalAccepted?.count}</td>
                          <td>{details?.notUpdated?.count}</td>
                          <td>{details?.completed_wrong_uploaded?.count}</td>
                          <td>{details?.completed_draft_uploaded?.count}</td>
                          <td>
                            {details?.completed_under_process_uploaded?.count}
                          </td>
                          <td>
                            {details?.completed_first_draft_uploaded?.count}
                          </td>
                          <td>
                            {details?.completed_in_review_uploaded?.count}
                          </td>
                          <td>{details?.completed?.count}</td>
                          <td>{details?.completed_uploaded?.count}</td>
                          <td>{details?.completed_not_uploaded?.count}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="">
                      <tr>
                        <th className="text-start">Total</th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.totalStudents?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.notUpdated?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.finalAccepted?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.notUpdated?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.completed_wrong_uploaded?.count ||
                                0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.completed_draft_uploaded?.count ||
                                0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.completed_under_process_uploaded
                                ?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.completed_first_draft_uploaded
                                ?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.completed_in_review_uploaded
                                ?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.completed?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.completed_uploaded?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {visaUserWiseReport.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.completed_not_uploaded?.count || 0),
                            0
                          )}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>Data is loading...</p>
      )}
    </div>
  );
};

export default CvTables;
